<script setup>
import TvStationsLogoFooter from '@/components/elements/TvStationsLogoFooter.vue'

const openConsent = () => {
  window.scrollTo(0, 0)
  window.openConsentWindow()
}
</script>
<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__container">
        <div class="columns is-multiline">
          <div class="column is-3-desktop is-12-tablet is-12-mobile">
            <div class="footer__social">
              <div class="footer__social-logo">
                <img src="../../assets/images/logos/tvp-info-black-logo.svg" alt="TVP Info logo" />
              </div>
              <div class="footer__social-media">
                <a href="https://www.facebook.com/tvp.info" class="facebook" target="_blank">
                  <i class="social-icon icon-facebook"></i>
                </a>
                <a href="http://twitter.com/tvp_info" class="twitter" target="_blank">
                  <i class="social-icon icon-twitter-new black"></i>
                </a>
                <a href="https://www.youtube.com/user/YTtvpinfo" class="youtube" target="_blank">
                  <i class="social-icon icon-youtube black"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="column is-3-desktop is-6-tablet is-12-mobile">
            <div class="footer__wrapper">
              <ul>
                <li class="footer__box">
                  <a href="https://vod.tvp.pl/page/regulamin,1653650" class="footer__detail"
                    >Regulamin TVP</a
                  >
                </li>
                <li class="footer__box">
                  <a href="https://polityka-prywatnosci.tvp.pl/" class="footer__detail"
                    >Polityka prywatności</a
                  >
                </li>
                <li class="footer__box">
                  <a href="#" @click="openConsent" class="footer__detail">Moje zgody</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="column is-3-desktop is-6-tablet is-12-mobile">
            <div class="footer__wrapper">
              <ul>
                <li class="footer__box">
                  <a href="https://brtvp.pl/" class="footer__detail">Biuro Reklamy TVP</a>
                </li>
                <li class="footer__box">
                  <a href="https://www.tvp.pl/nadawca#tvp_info" class="footer__detail"
                    >Informacje o nadawcy</a
                  >
                </li>
                <li class="footer__box">
                  <a href="/kontakt" class="footer__detail">Kontakt</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="column is-3-desktop is-12-tablet is-12-mobile">
            <!-- Banner do LP -->
            <a class="footer__app-banner" href="/aplikacja">
              <img src="@/assets/images/banner/banner-footer.png" alt="App" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="footer__wrap">
      <div class="footer__content">
        <ul class="footer__menu">
          <li class="footer__news">
            <a href="http://bialystok.tvp.pl/" class="footer__item">Białystok</a>
          </li>
          <li class="footer__news">
            <a href="http://bydgoszcz.tvp.pl/" class="footer__item">Bydgoszcz</a>
          </li>
          <li class="footer__news">
            <a href="http://gdansk.tvp.pl/" class="footer__item">Gdańsk</a>
          </li>
          <li class="footer__news">
            <a href=" http://gorzow.tvp.pl/ " class="footer__item">Gorzów WLKP.</a>
          </li>
          <li class="footer__news">
            <a href="http://katowice.tvp.pl/" class="footer__item">Katowice</a>
          </li>
          <li class="footer__news">
            <a href=" http://kielce.tvp.pl/" class="footer__item">Kielce</a>
          </li>
          <li class="footer__news">
            <a href=" http://krakow.tvp.pl/" class="footer__item">Kraków</a>
          </li>
          <li class="footer__news">
            <a href="http://lublin.tvp.pl/" class="footer__item">Lublin</a>
          </li>
          <li class="footer__news footer__show">
            <a href="http://lodz.tvp.pl/" class="footer__item">Łódź</a>
          </li>
          <li class="footer__news footer__show">
            <a href="http://olsztyn.tvp.pl/" class="footer__item">Olsztyn</a>
          </li>
          <li class="footer__news footer__show">
            <a href="http://opole.tvp.pl/" class="footer__item">Opole</a>
          </li>
        </ul>
        <ul class="footer__menu footer__last">
          <li class="footer__news footer__hide">
            <a href="http://lodz.tvp.pl/" class="footer__item">Łódź</a>
          </li>
          <li class="footer__news footer__hide">
            <a href="http://olsztyn.tvp.pl/" class="footer__item">Olsztyn</a>
          </li>
          <li class="footer__news footer__hide">
            <a href="http://opole.tvp.pl/" class="footer__item">Opole</a>
          </li>
          <li class="footer__news">
            <a href="http://poznan.tvp.pl/" class="footer__item">Poznań</a>
          </li>
          <li class="footer__news">
            <a href="http://rzeszow.tvp.pl/" class="footer__item">Rzeszów</a>
          </li>
          <li class="footer__news">
            <a href="http://szczecin.tvp.pl/" class="footer__item">Szczecin</a>
          </li>
          <li class="footer__news">
            <a href="http://warszawa.tvp.pl/" class="footer__item">Warszawa</a>
          </li>
          <li class="footer__news">
            <a href="http://wroclaw.tvp.pl/" class="footer__item">Wrocław</a>
          </li>
        </ul>
      </div>
    </div>
    <tv-stations-logo-footer />
    <div class="footer__copyright">
      <p class="footer__use">© 2024 Telewizja Polska S. A. w likwidacji</p>
    </div>
    <div class="stickyad"></div>
  </footer>
</template>

<style lang="scss">
@import '@/assets/scss/components/layout/footer-layout.scss';
</style>
